import { Injectable } from '@angular/core';
import { MatSnackBar, MatSnackBarRef } from '@angular/material/snack-bar';
import { StackedSnackbarComponent } from '../../shared/components/stacked-snackbar/stacked-snackbar.component';

export interface SnackbarMessage {
  date: Date | string;
  title: string;
  subtitle?: string;
  text?: string;
  user?: string;
}

@Injectable({ providedIn: 'root' })
export class StackedSnackbarService {
  private messages: SnackbarMessage[] = [];
  private ref?: MatSnackBarRef<StackedSnackbarComponent>;

  constructor(private snackBar: MatSnackBar) {}

  add(message: SnackbarMessage) {
    message.date = message.date ?? new Date();
    this.messages.unshift(message);

    if (!this.ref) {
      this.ref = this.snackBar.openFromComponent(StackedSnackbarComponent, {
        data: [],
        horizontalPosition: 'end',
        verticalPosition: 'top',
        panelClass: 'stacked-snackbar-container',
        duration: undefined,
      });

      setTimeout(() => {
        if (this.ref?.instance) {
          this.ref.instance.messages.set([...this.messages]);
        }
      });

      this.ref.afterDismissed().subscribe(() => {
        this.ref = undefined;
        this.messages = [];
      });
    } else {
      this.ref.instance.messages.set([...this.messages]);
    }
  }

  show(data: any) {}

  close(index: number) {
    this.messages.splice(index, 1);

    if (this.ref?.instance) {
      this.ref.instance.messages.set([...this.messages]);

      if (this.messages.length === 0) {
        this.ref.dismiss();
        this.ref = undefined;
      }
    }
  }
}
